<template>
  <Modal
    :modal="modal"
    title="Informação"
    :titleIcons="[]"
    @close="$emit('close')"
    @save="$emit('close')"
  >
    <template v-for="(erro, i) in erros">
      <v-alert
        class="mb-0"
        :key="i"
        dense
        outlined
        type="error"
      >
        {{ erro }}
      </v-alert>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/shared/Modal';

export default {
  name: 'ModalError',
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    erros: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Modal
  }
}
</script>

<style>

</style>